import { Box, Text } from '@mantine/core'

export function AppFooter() {
  return (
    <Box
      component="footer"
      style={{
        backgroundColor: 'var(--ai-card-bg)',
        borderTop: '1px solid var(--ai-border-light)',
        padding: '8px 30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Text size="xs" c="dimmed">
        Copyright &copy; 2025-2026 <strong>Amazonas Inovare</strong>. All rights reserved.
      </Text>
    </Box>
  )
}
